import React from "react";
import { Button } from "antd";

type DashboardLoadErrorProps = {
    message: string;
    onRetry: () => void;
};

const DashboardLoadError: React.FC<DashboardLoadErrorProps> = ({ message, onRetry }) => (
    <div role="alert" className="dashboard-load-error">
        {message}
        <Button type="link" onClick={onRetry}>
            Retry
        </Button>
    </div>
);

export default DashboardLoadError;
